export default __webpack_public_path__ + "static/media/to-do-list-desktop.681b2879.png";